export default class Social {
    constructor() {
        this.setEvents();
    }

    setEvents() {
        $('.social__circle--twitter').on('click', this.shareOnTwitter.bind(this));
        $('.social__circle--facebook').on('click', this.shareOnFacebook.bind(this));
    }

    shareOnFacebook(event) {
        this.constructor.openToNewWindow(event, 580, 555);
    }

    shareOnTwitter(event) {
        this.constructor.openToNewWindow(event, 520, 550);
    }

    static openToNewWindow(event, height, width) {
        const target = event.currentTarget;

        window.open(
            target.href,
            target.innerText,
            `width=${width}, height=${height}, scrollbars=1`,
        );

        event.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./frontend/js/modules/social.js